(() => {
  const binde = (wahl) => {
    if (wahl.__sone) return;
    wahl.__sone = true;
    const abschnitt = wahl.closest('.sone');
    const folge = abschnitt && abschnitt.querySelector('[data-oau]');
    if (!folge) return;
    const knoepfe = [...wahl.querySelectorAll('input')];
    wahl.addEventListener('click', (ev) => {
      if (!ev.target.matches('input')) return;
      if (folge.__oau && folge.__oau.waehle) folge.__oau.waehle(+ev.target.value);
    });
    folge.addEventListener('oau:bild', (ev) => {
      const k = knoepfe[ev.detail];
      if (k) k.checked = true;
    });
  };
  const sprache = (ort) => {
    const wurzel = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    if (wurzel === '/') return;
    (ort || document).querySelectorAll('.sone a[href^="/"]').forEach((a) => {
      const h = a.getAttribute('href');
      if (!h.startsWith(wurzel)) a.setAttribute('href', wurzel + h.replace(/^\//, ''));
    });
  };
  const alle = (ort) => { (ort || document).querySelectorAll('[data-sone-wahl]').forEach(binde); sprache(ort); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => alle());
  else alle();
  document.addEventListener('shopify:section:load', (e) => alle(e.target));
})();
